import React, { useState, useEffect } from "react";
import { Button, Popper, Paper, MenuList, MenuItem, Box } from "@mui/material";
import { HeaderWrapper, LeftContent, RightButtonContent } from "../StyledComponent";
import { useHistory } from "react-router-dom";
import OwnerDialog from "./ApplicationTracker/OwnerDialog";
import UserManualPopup from "../ManualShow";
import WhatsNewPopup from "../ManualShow/WhatsNew";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";
import axios from "axios";
import { useTranslation } from "react-i18next";

/* ------------------ REUSABLE HOVER MENU ------------------ */
function HoverMenu({ label, children }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  return (
    <Box sx={{ display: "inline-block" }} onMouseEnter={(e) => setAnchorEl(e.currentTarget)} onMouseLeave={() => setAnchorEl(null)}>
      <Button className="btn-header-menu">{label}</Button>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        disablePortal
        sx={{
          zIndex: 1300,
          top: "-8px !important",
        }}
      >
        <Paper elevation={4} sx={{ borderRadius: "0px 0px 10px 10px" }}>
          <MenuList autoFocusItem={false}>{children}</MenuList>
        </Paper>
      </Popper>
    </Box>
  );
}

function DepartmentPanel({ setApplicationFlow, setShowDuePaymentGroup }) {
  const { t } = useTranslation();
  const history = useHistory();
  const isLTPGradingEnabled = process.env.REACT_APP_ENABLE_LTP_GRADING === "true";
  /* ------------------ RIBBON MESSAGE (BACKEND DRIVEN) ------------------ */
  const [ribbonMessage, setRibbonMessage] = useState("");

  /* ------------------ EXISTING STATES ------------------ */
  const [aboutUsOpen, setAboutUsOpen] = useState(false);
  const [downloadsOpen, setDownloadsOpen] = useState(false);
  const [whatsNewsOpen, setWhatsNewsOpen] = useState(false);
  const [openOwner, setOpenOwner] = useState(false);
  const [openCitizen, setOpenCitizen] = useState(false);

  /* ------------------ FETCH RIBBON MESSAGE ------------------ */
  useEffect(() => {
    const fetchRibbonMessage = async () => {
      try {
        const res = await axios.post(`${Urls.UserManualSearch}?isApproved=RIBBON_MESSAGE`, { RequestInfo: { apiId: "Rainmaker" } });

        const manuals = res?.data?.UserManual || [];

        if (!manuals.length) {
          setRibbonMessage("");
          return;
        }

        // ✅ TAKE LATEST RECORD (NOT FIRST, NOT SORT)
        const latest = manuals[manuals.length - 1];

        setRibbonMessage(latest?.description?.trim() || "");
      } catch (e) {
        console.error("Ribbon fetch failed", e);
      }
    };

    fetchRibbonMessage();
  }, []);

  return (
    <React.Fragment>
      {/* ================== RIBBON MARQUEE ================== */}
      {ribbonMessage && (
        <Box
          sx={{
            width: "100%",
            overflow: "hidden",
            backgroundColor: "#c62828",
            color: "#fff",
            py: 1,
            zIndex: 1500,
          }}
        >
          <Box
            sx={{
              display: "inline-block",
              whiteSpace: "nowrap",
              paddingLeft: "100vw",
              animation: "ribbon-scroll 17s linear infinite",
              fontWeight: 600,
            }}
            dangerouslySetInnerHTML={{ __html: ribbonMessage }}
          />
        </Box>
      )}

      {/* ================== HEADER ================== */}
      <HeaderWrapper className="menu-header">
        <LeftContent>
          <Button className="btn-header-menu" onClick={() => setAboutUsOpen(true)}>
            {t("FASTPAS.HOME.GOV_HEADER.ABOUT_US")}
          </Button>

          <HoverMenu label={t("FASTPAS.HOME.GOV_HEADER.DOWNLOADS")}>
            <MenuItem onClick={() => setDownloadsOpen(true)}>{t("FASTPAS.HOME.RESOURCES.MANUAL_AND_DOCUMENT")}</MenuItem>
            <MenuItem onClick={() => setWhatsNewsOpen(true)}>{t("FASTPAS.HOME.RESOURCES.WHATS_NEW")}</MenuItem>
          </HoverMenu>

          <HoverMenu label={t("FASTPAS.HOME.NAV.TRACK_APPLICATION")}>
            <MenuItem onClick={() => setOpenOwner(true)}>{t("FASTPAS.HOME.CITIZEN.OWNER")}</MenuItem>
            <MenuItem onClick={() => setOpenCitizen(true)}>{t("FASTPAS.HOME.CITIZEN.CITIZEN_LABEL")}</MenuItem>
          </HoverMenu>

          {/* <HoverMenu label={t("Online Payments")}>
            <MenuItem onClick={() => setShowDuePaymentGroup(true)}>{t("FASTPAS.HOME.PAYMENT.CHALLAN_PAYMENT")}</MenuItem>
          </HoverMenu> */}

          {/* {isLTPGradingEnabled && (
            <Button className="btn-header-menu" onClick={() => history.push("/digit-ui/citizen/ltpGrading")}>
              {t("FASTPAS.HOME.NAV.LTP_GRADING")}
            </Button>
          )} */}
          <Button className="btn-header-menu" onClick={() => history.push("/digit-ui/citizen/ltpGrading")}>
            {t("FASTPAS.HOME.NAV.LTP_GRADING")}
          </Button>

          <Button
            className="btn-header-menu"
            onClick={() => window.open("https://epay.sbi.bank.in/secure/transactionTrack", "_blank", "noopener,noreferrer")}
          >
            {t("FASTPAS.HOME.NAV.CHECK_PAYMENT")}
          </Button>
        </LeftContent>

        <RightButtonContent />
      </HeaderWrapper>

      {/* ================== POPUPS ================== */}
      <UserManualPopup open={downloadsOpen} onClose={() => setDownloadsOpen(false)} />
      <WhatsNewPopup open={whatsNewsOpen} onClose={() => setWhatsNewsOpen(false)} />
      <OwnerDialog open={openOwner} onClose={() => setOpenOwner(false)} />
      <OwnerDialog type="citizen" open={openCitizen} onClose={() => setOpenCitizen(false)} />

      {/* ================== MARQUEE ANIMATION ================== */}
      <style>
        {`
          @keyframes ribbon-scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-100%); }
          }
        `}
      </style>
    </React.Fragment>
  );
}

export default DepartmentPanel;
